import { Component } from 'react';

import classNames from 'classnames';
import _ from 'lodash';
import { defineMessages, injectIntl } from 'react-intl';
import { Fields } from 'redux-form';

import styles from './DateInput.module.css';
import { months } from '../../helpers/months';
import { FormField } from '../formField';
import { FormFieldError } from '../FormFieldError/FormFieldError';
import { Select } from '../select';

const monthMessages = defineMessages({
    january: {
        id: '_.date_input.january',
        defaultMessage: 'January'
    },
    february: {
        id: '_.date_input.february',
        defaultMessage: 'February'
    },
    march: {
        id: '_.date_input.march',
        defaultMessage: 'March'
    },
    april: {
        id: '_.date_input.april',
        defaultMessage: 'April'
    },
    may: {
        id: '_.date_input.may',
        defaultMessage: 'May'
    },
    june: {
        id: '_.date_input.june',
        defaultMessage: 'June'
    },
    july: {
        id: '_.date_input.july',
        defaultMessage: 'July'
    },
    august: {
        id: '_.date_input.august',
        defaultMessage: 'August'
    },
    september: {
        id: '_.date_input.september',
        defaultMessage: 'September'
    },
    october: {
        id: '_.date_input.october',
        defaultMessage: 'October'
    },
    november: {
        id: '_.date_input.november',
        defaultMessage: 'November'
    },
    december: {
        id: '_.date_input.december',
        defaultMessage: 'December'
    }
});

class DateInput extends Component {
    renderError(fields) {
        const fieldWithError = _.find(
            fields,
            (field) => field.meta.touched && field.meta.error
        );

        if (fieldWithError) {
            return (
                fieldWithError.meta.touched &&
                fieldWithError.meta.error && (
                    <FormFieldError message={fieldWithError.meta.error} />
                )
            );
        }
    }

    renderDate = (props) => {
        const {
            fieldName,
            validateHandler,
            names,
            placeholder,
            onChangeHandler,
            disabled
        } = props;

        const field = props[fieldName];

        const renderError = this.renderError(field);

        const dateField = {
            day: names[0],
            month: names[1],
            year: names[2]
        };

        return (
            <>
                {renderError}
                <div className={styles.fields}>
                    <FormField
                        disabled={disabled}
                        placeholder={placeholder.day}
                        className={classNames(styles.day, 'fs-exclude')}
                        onChangeHandler={onChangeHandler}
                        name={dateField.day}
                        data-testid="dob-day-input"
                        validate={validateHandler}
                        hideError={true}
                    />
                    <Select
                        disabled={disabled}
                        className={classNames(styles.month, 'fs-exclude')}
                        name={dateField.month}
                        onChange={onChangeHandler}
                        validate={validateHandler}
                        hideError={true}
                        placeholder={placeholder.month}
                        messages={monthMessages}
                        selectOptions={{ options: months }}
                        data-testid="dob-month-input"
                    />
                    <FormField
                        disabled={disabled}
                        placeholder={placeholder.year}
                        className={classNames(styles.year, 'fs-exclude')}
                        onChangeHandler={onChangeHandler}
                        name={dateField.year}
                        data-testid="dob-year-input"
                        validate={validateHandler}
                        hideError={true}
                    />
                </div>
            </>
        );
    };

    render() {
        const { intl, value, label, name, validate, onChange, disabled } =
            this.props;

        const names = [`${name}.day`, `${name}.month`, `${name}.year`];

        const placeholder = {
            day: intl.formatMessage({
                id: '_.date_input.day',
                defaultMessage: 'Day'
            }),
            month: intl.formatMessage({
                id: '_.date_input.month',
                defaultMessage: 'Month'
            }),
            year: intl.formatMessage({
                id: '_.date_input.year',
                defaultMessage: 'Year'
            })
        };

        return (
            <div className={styles.Date}>
                <label className={styles.label}>{label}</label>
                <Fields
                    disabled={disabled}
                    placeholder={placeholder}
                    inputValue={value}
                    onChangeHandler={onChange}
                    validateHandler={validate}
                    fieldName={name}
                    names={names}
                    component={this.renderDate}
                />
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default injectIntl(DateInput);
